module.exports = __webpack_public_path__ + "static/media/tcs_small_logo1.2e068a4a.png";